/**
 * Coleção: theme.collectionPage, theme.filter (activeFilters, priceRange),
 * Ordenação: só dentro da gaveta de filtros (#FilterForm, acordeão com radios sort_by).
 * Depende de global.js (theme, utilities, component, storageKeys), base.js,
 * product.js em runtime (customSwatchColors no render da coleção).
 *
 * Ordem no layout: após global.js; antes de shipping-rates.js ou cart.js.
 */

theme.collectionPage = {
    container: document.querySelector(".collection"),
    productList: document.querySelector(".collection__product-list"),
    productGrid: document.getElementById("product-grid"),
    render: function () {
      if (this.productList) {
        theme.filter.render();
        window.addEventListener(
            "popstate",
            this.handlePopstateEvent.bind(this)
          );
      }
    },
    handlePopstateEvent: function (e) {
      var t = document.getElementById("product-grid").dataset.id;
      (e = e.state ? e.state.params : ""),
        (t = window.location.pathname + `?section_id=${t}&` + e),
        theme.filter.getProductList(t);
    },
  };

  theme.filter = {
    filterForm: document.getElementById("FilterForm"),
    productGrid: document.getElementById("product-grid"),
    selectors: {
      productContainer: "ProductGridContainer",
      productGrid: "product-grid",
      filters: "ProductFilters",
      filtersMobile: "ProductFiltersMobile",
      filterTags: "filterByTag",
      activeTags: "CollectionActiveTags",
      resultsLabel: "FilterResultsLabel",
      activeCount: "FilterActiveCount",
    },
    productGridContainer: document.getElementById("ProductGridContainer"),
    render: function () {
      this.filterForm &&
        (this.filterForm.addEventListener(
          "change",
          this.handleFormChange.bind(this)
        ),
          this.priceRange.init(),
          this.renderActiveFilters());
      // As cores das amostras vêm de theme.product (product.js, carregado depois deste arquivo)
      if (document.readyState === "complete") this.renderSwatchFilter();
      else document.addEventListener("DOMContentLoaded", () => this.renderSwatchFilter(), { once: true });
    },
    // Várias mudanças no mesmo instante (as duas alças do preço disparam "change" juntas) = uma busca só.
    handleFormChange: function (e) {
      e.preventDefault();
      clearTimeout(this.changeTimer);
      this.changeTimer = setTimeout(() => {
        var params = this.getSearchParams();
        this.updateURL(params);
        this.getProductList(theme.utilities.getSectionUrl(params));
      }, 0);
    },
    // Filtros + ordenação da gaveta (#FilterForm)
    getSearchParams: function () {
      var filterForm = document.getElementById("FilterForm");
      return new URLSearchParams(filterForm ? new FormData(filterForm) : undefined).toString();
    },
    getProductList: function (e) {
      let t = this;
      let drawer = document.getElementById("FilterDrawer");
      drawer && drawer.classList.add("is-loading");
      this.productGrid.classList.remove("finished"),
        this.productGrid.classList.add("loading"),
        fetch(e)
          .then((e) => e.text())
          .then((e) => {
            this.productGrid.classList.add("loaded"),
              this.productGrid.classList.remove("loading"),
              this.renderProductGrid(e),
              this.renderProductFilters(e),
              setTimeout(function () {
                t.productGrid.classList.add("finished"),
                  t.productGrid.classList.remove("loaded");
              }, 300);
          })
          .finally(() => {
            drawer && drawer.classList.remove("is-loading");
          });
    },
    renderProductGrid: function (e) {
      let t = new DOMParser().parseFromString(e, "text/html"),
        i = this.productGrid.className;
      let n = t.querySelector(".collection__product-list");
      n &&
        ((this.productGridContainer.innerHTML = t.getElementById(
            this.selectors.productContainer
          ).innerHTML),
          window.scrollTo({
            top: this.productGridContainer.offsetTop - 100,
            behavior: "smooth",
          }),
          (this.productGrid = document.getElementById(
            this.selectors.productGrid
          )),
          (this.productGrid.className = i),
          theme.utilities.applyAnimation());
    },
    renderProductFilters: function (e) {
      (e = new DOMParser().parseFromString(e, "text/html")),
        (document.getElementById(this.selectors.filters).innerHTML =
          e.getElementById(this.selectors.filters).innerHTML),
        (document.getElementById(this.selectors.activeTags).innerHTML =
          e.getElementById(this.selectors.activeTags).innerHTML),
        this.renderCounters(e),
        this.renderPriceRange(),
        (this.filterForm = document.getElementById("FilterForm")),
        this.filterForm.addEventListener(
          "change",
          this.handleFormChange.bind(this)
        ),
        this.renderActiveFilters(),
        this.renderSwatchFilter(),
        teamdropInitTooltips(document);
    },
    // "Ver resultados (N)" no rodapé da gaveta e contador de filtros ativos do botão flutuante
    renderCounters: function (doc) {
      [this.selectors.resultsLabel, this.selectors.activeCount].forEach(function (id) {
        var current = document.getElementById(id);
        var next = doc.getElementById(id);
        if (!current || !next) return;
        current.textContent = next.textContent;
        current.hidden = next.hidden;
      });
    },
    renderPriceRange: function () {
      let e = Object.create(this.priceRange);
      (e.min = {
        control: document.querySelector(".price-bar__control--min"),
        input: document.querySelector(".filter-price__input--min"),
      }),
        (e.max = {
          control: document.querySelector(".price-bar__control--max"),
          input: document.querySelector(".filter-price__input--max"),
        }),
        (e.bar = document.querySelector(".price-bar")),
        (e.activeBar = document.querySelector(".price-bar__active")),
        e.init();
    },
    updateURL: function (e) {
      history.pushState({ params: e }, "", window.location.pathname + "?" + e);
    },
    renderActiveFilters: function () {
      let e = Object.create(this.activeFilters);
      (e.appliedFilters = document.querySelectorAll("#CollectionActiveTags a")),
        e.render();
    },
    // Cor das bolinhas (filtro e chips) pela lista "Cores das amostras" do tema, quando a Shopify não mandou cor
    renderSwatchFilter: function () {
      let els = document.querySelectorAll(".collection-filters__swatch[data-swatch], .filter-chips__swatch[data-swatch]");
      if (!els.length || !theme.product || !theme.product.swatchStyle) return;
      els.forEach((el) => {
        if (el.style.getPropertyValue("--swatch-background-color")) return;
        let css = theme.product.swatchStyle(el.dataset.swatch);
        css && (el.style.cssText += ";" + css);
      });
    },
  };

  theme.filter.activeFilters = {
    appliedFilters: document.querySelectorAll("#CollectionActiveTags a"),
    render: function () {
      0 !== this.appliedFilters.length &&
        this.appliedFilters.forEach((e) => {
          e.addEventListener(
            "click",
            this.handleActiveFilterOnClick.bind(this)
          );
        });
    },
    handleActiveFilterOnClick: function (e) {
      e.preventDefault(),
        (e =
          -1 == e.currentTarget.href.indexOf("?")
            ? ""
            : e.currentTarget.href.slice(
              e.currentTarget.href.indexOf("?") + 1
            ));
      var t =
        (theme.filter.updateURL(e),
          document.getElementById("product-grid").dataset.id);
      (t = window.location.pathname + `?section_id=${t}&` + e),
        theme.filter.getProductList(t);
    },
  };

  theme.filter.priceRange = {
    min: {
      control: document.querySelector(".price-bar__control--min"),
      input: document.querySelector(".filter-price__input--min"),
    },
    max: {
      control: document.querySelector(".price-bar__control--max"),
      input: document.querySelector(".filter-price__input--max"),
    },
    bar: document.querySelector(".price-bar"),
    activeBar: document.querySelector(".price-bar__active"),
    offsetX: 0,

    init: function () {
      this.min.control &&
        ((this.min.value = parseInt(this.min.input.value || this.min.input.placeholder)),
          (this.max.value = parseInt(this.max.input.value || this.max.input.placeholder)),
          (this.minValue = parseInt(this.min.input.getAttribute("min"))),
          (this.maxValue = parseFloat(this.max.input.getAttribute("max")) + 1),
          (this.barWidth = this.bar.offsetWidth),
          (this.ratioWidthMaxValue = this.maxValue / this.barWidth),
          (this.ratioPriceValue = 100 / (this.maxValue - this.minValue)),
          this.setEvents(),
          this.setInputEvents(),
          this.applyControlPosition(this.min),
          this.applyControlPosition(this.max));
    },

    setEvents: function () {
      [this.min.control, this.max.control].forEach((control) => {
        control.addEventListener("mousedown", this.handleMouseDown.bind(this));
        control.addEventListener("touchstart", this.handleTouchStart.bind(this), { passive: false });
      });
    },

    handleMouseDown: function (e) {
      e.preventDefault();
      this.activeSlider = e.currentTarget === this.min.control ? this.min : this.max;
      this.offsetX = e.clientX - this.activeSlider.control.getBoundingClientRect().left;

      this.boundHandleMouseMove = this.handleMouseMove.bind(this);
      this.boundHandleMouseUp = this.handleMouseUp.bind(this);

      window.addEventListener("mousemove", this.boundHandleMouseMove);
      window.addEventListener("mouseup", this.boundHandleMouseUp);
    },

    handleMouseMove: function (e) {
      let mouseX = e.clientX - this.offsetX;
      this.updateSliderPosition(mouseX);
    },

    handleMouseUp: function () {
      window.removeEventListener("mousemove", this.boundHandleMouseMove);
      window.removeEventListener("mouseup", this.boundHandleMouseUp);
      this.triggerInputChange();
    },

    handleTouchStart: function (e) {
      e.preventDefault();
      let touch = e.touches[0];
      this.activeSlider = e.currentTarget === this.min.control ? this.min : this.max;
      this.offsetX = touch.clientX - this.activeSlider.control.getBoundingClientRect().left;

      this.boundHandleTouchMove = this.handleTouchMove.bind(this);
      this.boundHandleTouchEnd = this.handleTouchEnd.bind(this);

      window.addEventListener("touchmove", this.boundHandleTouchMove, { passive: false });
      window.addEventListener("touchend", this.boundHandleTouchEnd);
    },

    handleTouchMove: function (e) {
      e.preventDefault();
      let touchX = e.touches[0].clientX - this.offsetX;
      this.updateSliderPosition(touchX);
    },

    handleTouchEnd: function () {
      window.removeEventListener("touchmove", this.boundHandleTouchMove);
      window.removeEventListener("touchend", this.boundHandleTouchEnd);
      this.triggerInputChange();
    },

    updateSliderPosition: function (posX) {
      let barRect = this.bar.getBoundingClientRect();
      let barLeft = barRect.left;
      let barWidth = barRect.width;

      let t = Math.ceil(((posX - barLeft) / barWidth) * this.maxValue);
      t = Math.max(this.minValue, Math.min(t, this.maxValue));

      if (this.activeSlider === this.min) {
        this.min.input.value = t > this.max.value ? this.max.value : t;
        this.min.value = this.min.input.value;
        this.applyControlPosition(this.min);
      } else {
        this.max.input.value = t < this.min.value ? this.min.value : t;
        this.max.value = this.max.input.value;
        this.applyControlPosition(this.max);
      }
    },

    applyControlPosition: function (e) {
      e.control.style.left = (e.value - this.minValue) * this.ratioPriceValue + "%";
      this.activeBar.style.left = (this.min.value - this.minValue) * this.ratioPriceValue + "%";
      this.setActiveBarWidth();
    },

    setActiveBarWidth: function () {
      this.activeBar.style.width = this.calculateActiveBarWidth() + "%";
    },

    calculateActiveBarWidth: function () {
      return ((this.max.value - this.min.value) / this.maxValue) * 100;
    },

    triggerInputChange: function () {
      [this.min.input, this.max.input].forEach((input) => {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    },

    setInputEvents: function () {
      [this.min.input, this.max.input].forEach((input) => {
        input.addEventListener("change", this.handleInputChange.bind(this));
      });
    },

    handleInputChange: function (e) {
      e.preventDefault();
      let t = parseInt(e.currentTarget.value);
      if (e.currentTarget === this.min.input) {
        this.min.input.value = t > this.max.value ? this.max.value : t;
        this.min.value = this.min.input.value;
        this.applyControlPosition(this.min);
      } else {
        this.max.input.value = t < this.min.value ? this.min.value : t;
        this.max.value = this.max.input.value;
        this.applyControlPosition(this.max);
      }
    },
};


document.addEventListener("shopify:section:load", function (event) {
  if (!event.target || !event.target.querySelector(".collection")) return;
  theme.collectionPage.container = document.querySelector(".collection");
  theme.collectionPage.productList = document.querySelector(".collection__product-list");
  theme.collectionPage.productGrid = document.getElementById("product-grid");
  theme.collectionPage.render();
});

// Auto-init: script defer roda após DOM parseado.
theme.collectionPage.render();
